export const getVimeoEmbedURL = (videoId: string, unlistedHash: string | undefined) => {
  return `https://player.vimeo.com/video/${videoId}${unlistedHash ? `?h=${unlistedHash}` : ''}`
}
